// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetMiniBasketRequestModel from '../../model/get-mini-basket-request-model';
import GetMiniBasketRequestDTO from '../dto/get-mini-basket-request-dto';
import dtoSchema from '../schemas/get-mini-basket-request-schema';

export default abstract class GetMiniBasketRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetMiniBasketRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
      this.publicBasketId = data.publicBasketId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;
  /**
  * @type {uuid}
  */
  publicBasketId?: string;

  static toModel(dto: DeepPartial<GetMiniBasketRequestDTO>): GetMiniBasketRequestModel;
  static toModel(dto: DeepPartial<GetMiniBasketRequestDTO> | undefined | null): GetMiniBasketRequestModel | undefined;
  static toModel(dto: DeepPartial<GetMiniBasketRequestDTO> | undefined | null): GetMiniBasketRequestModel | undefined {
    return dto ? new GetMiniBasketRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetMiniBasketRequestModel> | GetMiniBasketRequestModel): GetMiniBasketRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
      publicBasketId: unwrapped.publicBasketId,
    } as GetMiniBasketRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetMiniBasketRequestModel, can not map to GetMiniBasketRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
